module.exports = __webpack_public_path__ + "static/img/appletImg.3aff0cfb.jpg";